import { Reload, RequestState } from "@shared/platform-api/requests"
import { FromApiBase } from "./types"

export type FromApiForArray<T, I> = FromApiBase<I> & {
  data: ReadonlyArray<T>
}

export const useApiForArray = <T, I>(res: RequestState<ReadonlyArray<T>>, reload: Reload<I>): FromApiForArray<T, I> => {
  if (res.result?.tag === `err`) {
    // eslint-disable-next-line no-console
    console.log(res.result.error)
  }
  return {
    data: res.result?.data || [],
    loading: res.loading || !res.result,
    apiErrored: res.result?.tag === `err`,
    reload,
  }
}
